import { WallType } from '@app-types/config';

import { PlanTypeId } from '@constants/plan';

export function isPlanCompatibleWithWall(type: WallType, planType: PlanTypeId) {
    let compatiblePLanType: PlanTypeId[] = [];

    switch (type) {
        case WallType.PHONE:
            compatiblePLanType = [
                PlanTypeId.IDEO,
                PlanTypeId.IDEO_PRO,
                PlanTypeId.PREMIUM,
                PlanTypeId.PREMIUM_RENEWAL,
                PlanTypeId.SOWO,
                PlanTypeId.SOWO_RENEWAL,
            ];
            break;
        case WallType.HOTSPOT:
            compatiblePLanType = [PlanTypeId.FAIM, PlanTypeId.FAIM_PREMIUM, PlanTypeId.FAIM_UNLIMITED];
            break;
    }

    return compatiblePLanType.includes(planType);
}
